import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/qtimes.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "55",
  alt: "logo"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "logo-header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Waiting times", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "support",
  href: "https://8erbahnfreaks.de"
}, "by 8erbahnFreaks.de", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("footer", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://8erbahnfreaks.de/impressum",
    target: "_blank"
  }, "Impressum"),
  /*#__PURE__*/_createTextVNode(" | Powered by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://queue-times.com",
    target: "_blank"
  }, "queue-times.com")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      (_ctx.$route.name === 'home')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.$route.name != 'login')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
            }, [
              _createVNode(_component_UserCircleIcon, { class: "icon" })
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
          placeholder: "search",
          class: "search-field"
        }, null, 512), [
          [_vModelText, _ctx.search]
        ])
      ])
    ]),
    _createVNode(_component_router_view, { search: _ctx.search }, null, 8, ["search"]),
    _hoisted_9
  ], 64))
}